import { p } from './core.js'

// Categoria 2 — Estantes + Nichos + Especiais (R3)
// Modelos: EST-AS-A..D, EST-AM-A..F, EST-B-A..D, NIC-A..F, EST-MESA-A, ARM-EST-A..B
// Regra: peças expostas (estante aberta, nicho aberto) → cor. Peças atrás de porta
// fechada → branco. Fundo 6mm sempre branco.

export const ESTANTES = {

  // ── EST-AS-A — Estante 4 Andares ────────────────────────────────────────────
  'Estante 4 Andares': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',    '15', v => v.P * v.A, 2),
      p('Tampo',      '15', v => v.C * v.P, 1),
      p('Base',       '15', v => v.C * v.P, 1),
      p('Prateleira', '15', v => v.C * v.P, 3),
      p('Fundo',      '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── EST-AS-B — Estante 5 Andares ────────────────────────────────────────────
  'Estante 5 Andares': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',    '15', v => v.P * v.A, 2),
      p('Tampo',      '15', v => v.C * v.P, 1),
      p('Base',       '15', v => v.C * v.P, 1),
      p('Prateleira', '15', v => v.C * v.P, 4),
      p('Fundo',      '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── EST-AS-D — Estante 3 Andares + Inferior Fechado com 2 Portas + Prat ─────
  // A_fechado padrão = A/3 (parte inferior fechada).
  'Estante com 2 Portas Inferiores': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                   '15', v => v.P * v.A, 2),
      p('Tampo',                     '15', v => v.C * v.P, 1),
      p('Base',                      '15', v => v.C * v.P, 1),
      p('Divisória horizontal',      '15', v => v.C * v.P, 1, 'branco'),
      p('Prateleira aberta',         '15', v => v.C * v.P, 2),
      p('Prateleira interna fechada','15', v => v.C * v.P, 1, 'branco'),
      p('Porta de giro',             '15', v => (v.C/2) * (v.A/3), 2),
      p('Fundo',                     '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── EST-AM-A — Estante Assimétrica 5 Andares (10 espaços) ───────────────────
  'Estante Assimétrica 5A 10 espaços': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1),
      p('Prateleira contínua',      '15', v => v.C * v.P, 4),
      p('Divisória vertical parcial','15', v => v.P * (v.A/5), 5),
      p('Fundo',                    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── EST-AM-B — Estante Assimétrica 4 Andares (10 espaços) ───────────────────
  'Estante Assimétrica 4A 10 espaços': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1),
      p('Prateleira contínua',      '15', v => v.C * v.P, 3),
      p('Divisória vertical parcial','15', v => v.P * (v.A/4), 6),
      p('Fundo',                    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── EST-AM-C — Estante Assimétrica 5 Andares (13 espaços) ───────────────────
  'Estante Assimétrica 5A 13 espaços': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1),
      p('Prateleira contínua',      '15', v => v.C * v.P, 4),
      p('Divisória vertical parcial','15', v => v.P * (v.A/5), 8),
      p('Fundo',                    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── EST-AM-D — Estante Dupla 4 Andares (8 nichos) ───────────────────────────
  'Estante Dupla 4 Andares': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                    '15', v => v.P * v.A, 2),
      p('Divisória vertical central', '15', v => v.P * v.A, 1),
      p('Tampo',                      '15', v => v.C * v.P, 1),
      p('Base',                       '15', v => v.C * v.P, 1),
      p('Prateleira contínua',        '15', v => v.C * v.P, 3),
      p('Fundo',                      '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── EST-AM-E — Estante Dupla 5 Andares (10 nichos) ──────────────────────────
  'Estante Dupla 5 Andares': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                    '15', v => v.P * v.A, 2),
      p('Divisória vertical central', '15', v => v.P * v.A, 1),
      p('Tampo',                      '15', v => v.C * v.P, 1),
      p('Base',                       '15', v => v.C * v.P, 1),
      p('Prateleira contínua',        '15', v => v.C * v.P, 4),
      p('Fundo',                      '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── EST-AM-F — Estante Tripla 5 Andares (15 nichos) ─────────────────────────
  'Estante Tripla 5 Andares': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Divisória vertical',       '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1),
      p('Prateleira contínua',      '15', v => v.C * v.P, 4),
      p('Fundo',                    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── EST-B-A — Estante Baixa 3 Andares ───────────────────────────────────────
  'Estante Baixa 3 Andares': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',    '15', v => v.P * v.A, 2),
      p('Tampo',      '15', v => v.C * v.P, 1),
      p('Base',       '15', v => v.C * v.P, 1),
      p('Prateleira', '15', v => v.C * v.P, 2),
      p('Fundo',      '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── EST-B-B — Estante Baixa Dupla 3 Andares (6 nichos) ──────────────────────
  'Estante Baixa Dupla 3 Andares': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',              '15', v => v.P * v.A, 2),
      p('Divisória vertical',   '15', v => v.P * v.A, 1),
      p('Tampo',                '15', v => v.C * v.P, 1),
      p('Base',                 '15', v => v.C * v.P, 1),
      p('Prateleira contínua',  '15', v => v.C * v.P, 2),
      p('Fundo',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── EST-B-C — Estante Baixa Assimétrica 3 Andares (6 espaços) ───────────────
  'Estante Baixa Assimétrica': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                    '15', v => v.P * v.A, 2),
      p('Tampo',                      '15', v => v.C * v.P, 1),
      p('Base',                       '15', v => v.C * v.P, 1),
      p('Prateleira contínua',        '15', v => v.C * v.P, 2),
      p('Divisória vertical parcial', '15', v => v.P * (v.A/3), 3),
      p('Fundo',                      '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── EST-B-D — Estante Baixa Quádrupla 2 Andares (8 nichos) ──────────────────
  'Estante Baixa Quádrupla': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',              '15', v => v.P * v.A, 2),
      p('Divisória vertical',   '15', v => v.P * v.A, 3),
      p('Tampo',                '15', v => v.C * v.P, 1),
      p('Base',                 '15', v => v.C * v.P, 1),
      p('Prateleira contínua',  '15', v => v.C * v.P, 1),
      p('Fundo',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── NIC-A — Nicho Quadrado (aberto, suspenso) ───────────────────────────────
  'Nicho Quadrado': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',  '15', v => v.P * v.A, 2),
      p('Tampo',    '15', v => v.C * v.P, 1),
      p('Base',     '15', v => v.C * v.P, 1),
      p('Fundo',    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── NIC-B — Nicho Retangular (mesmas peças do NIC-A) ────────────────────────
  'Nicho Retangular': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',  '15', v => v.P * v.A, 2),
      p('Tampo',    '15', v => v.C * v.P, 1),
      p('Base',     '15', v => v.C * v.P, 1),
      p('Fundo',    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── NIC-C — Nicho Vertical com Prateleira ───────────────────────────────────
  'Nicho Vertical com Prateleira': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',              '15', v => v.P * v.A, 2),
      p('Tampo',                '15', v => v.C * v.P, 1),
      p('Base',                 '15', v => v.C * v.P, 1),
      p('Prateleira horizontal','15', v => v.C * v.P, 1),
      p('Fundo',                '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── NIC-D — Nicho Horizontal com Divisória Central ──────────────────────────
  'Nicho Horizontal com Divisória': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',            '15', v => v.P * v.A, 2),
      p('Tampo',              '15', v => v.C * v.P, 1),
      p('Base',               '15', v => v.C * v.P, 1),
      p('Divisória vertical', '15', v => v.P * v.A, 1),
      p('Fundo',              '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── NIC-E — Nicho com Porta Basculante + Nicho Aberto ───────────────────────
  // Metade fechada (atrás da porta) tem interior branco; metade aberta é cor.
  'Nicho com Porta Basculante': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',           '15', v => v.P * v.A, 2),
      p('Tampo',             '15', v => v.C * v.P, 1),
      p('Base',              '15', v => v.C * v.P, 1),
      p('Divisória vertical','15', v => v.P * v.A, 1, 'branco'),
      p('Porta basculante',  '15', v => (v.C/2) * v.A, 1),
      p('Fundo',             '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 1, rodinha: 0, cabide: 0 },
  },

  // ── NIC-F — Nicho Composto: 2 Portas Basculantes + Prat + Divisória ─────────
  'Nicho Duplo com 2 Portas Basculantes': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                  '15', v => v.P * v.A, 2),
      p('Tampo',                    '15', v => v.C * v.P, 1),
      p('Base',                     '15', v => v.C * v.P, 1),
      p('Divisória vertical',       '15', v => v.P * v.A, 1, 'branco'),
      p('Prateleira contínua',      '15', v => v.C * v.P, 1, 'branco'),
      p('Porta basculante',         '15', v => (v.C/2) * (v.A/2), 2),
      p('Fundo',                    '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 2, rodinha: 0, cabide: 0 },
  },

  // ── EST-MESA-A — Estante Alta + Mesa Conjugadas ─────────────────────────────
  // 2 entradas independentes de profundidade (P_est vs P_mesa) e larguras (C_est, C_mesa).
  // Lateral compartilhada (entre estante e mesa) NÃO duplicada — está no "Lateral direita" da estante.
  // h_portas = 0.30, A_mesa = 0.75.
  'Estante com Mesa Conjugada': {
    entradas: ['C_est','C_mesa','P_est','P_mesa','A'],
    pecas: [
      p('Tampo estante',                          '15', v => v.C_est * v.P_est, 1),
      p('Base estante',                           '15', v => v.C_est * v.P_est, 1),
      p('Lateral estante (esquerda)',             '15', v => v.P_est * v.A, 1),
      p('Lateral estante (direita compartilhada)','15', v => v.P_est * v.A, 1),
      p('Prateleira interna estante',             '15', v => v.C_est * v.P_est, 3),
      p('Divisória horizontal (topo portas)',     '15', v => v.C_est * v.P_est, 1, 'branco'),
      p('Porta de giro base',                     '15', v => (v.C_est/2) * 0.30, 2),
      p('Tampo da mesa',                          '15', v => v.C_mesa * v.P_mesa, 1),
      p('Lateral direita da mesa (pé-painel)',    '15', v => v.P_mesa * 0.75, 1),
      p('Fundo da estante',                       '6',  v => v.C_est * v.A, 1),
    ],
    ferragens: { dobradica: 4, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── ARM-EST-A — Armário Estante 4 Andares ───────────────────────────────────
  // Base = EST-AM-D + 1 porta de giro cobrindo metade da frente (1 coluna fechada,
  // outra aberta). Tudo dentro do compartimento fechado = branco.
  'Armário Estante 4 Andares': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                    '15', v => v.P * v.A, 2),
      p('Divisória vertical central', '15', v => v.P * v.A, 1),
      p('Tampo',                      '15', v => v.C * v.P, 1),
      p('Base',                       '15', v => v.C * v.P, 1),
      // 3 prateleiras: metade exposta visível, metade atrás da porta. Aproximação:
      // declaro 1.5 expostas e 1.5 internas → arredondo 2/1 (peças inteiras).
      p('Prateleira contínua (lado aberto)', '15', v => (v.C/2) * v.P, 3),
      p('Prateleira contínua (lado fechado)','15', v => (v.C/2) * v.P, 3, 'branco'),
      p('Porta de giro',              '15', v => (v.C/2) * v.A, 1),
      p('Fundo',                      '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 3, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── ARM-EST-B — Armário Estante 5 Andares ───────────────────────────────────
  'Armário Estante 5 Andares': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                    '15', v => v.P * v.A, 2),
      p('Divisória vertical central', '15', v => v.P * v.A, 1),
      p('Tampo',                      '15', v => v.C * v.P, 1),
      p('Base',                       '15', v => v.C * v.P, 1),
      p('Prateleira contínua (lado aberto)', '15', v => (v.C/2) * v.P, 4),
      p('Prateleira contínua (lado fechado)','15', v => (v.C/2) * v.P, 4, 'branco'),
      p('Porta de giro',              '15', v => (v.C/2) * v.A, 1),
      p('Fundo',                      '6',  v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 3, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },
}
